<template>
    <div class="zz" :class="{ active: show }">
        <div class="exchange-code-box">
            <div class="exchange-code">
                <div class="header">兑换激活码</div>
                <div class="content">
                    <input
                        type="text"
                        v-model="code"
                        placeholder="请输入兑换码"
                    />
                </div>
                <div
                    v-if="msg"
                    class="msg"
                    :class="[status == 'success' ? 'success' : 'error']"
                >
                    {{ msg }}
                </div>
                <div class="btn submit" @click="checkCode()">确认</div>
            </div>
            <img
                @click="close()"
                class="close"
                src="~@/assets/close.png"
                alt=""
            />
        </div>
    </div>
</template>

<script>
import rx from "../../_rx";
import userCenterService from "../../service/user-center.service";
export default {
    name: "exchange-code",
    data() {
        return {
            show: false,
            code: "",
            msg: "",
            status: "",
        };
    },
    mounted() {
        rx.on("showExchangeCode", () => {
            this.show = true;
        });
    },
    methods: {
        close() {
            this.show = false;
        },
        checkCode() {
            this.msg = "";
            userCenterService
                .checkCode({ code: this.code })
                .then((res) => {
                    if (res.status == 200) {
                        this.status = "success";
                        setTimeout(() => {
                            location.reload();
                        }, 1000);
                    } else {
                        this.status = "error";
                    }
                    this.msg = res.data;
                })
                .catch(() => {
                    this.msg = "兑换失败";
                    this.status = "error";
                });
        },
    },
};
</script>

<style lang="scss" scoped src="./exchange-code.scss">
</style>